import { Extensions, CreationGroup } from '../interfaces'

export const IMAGE_MIMETYPE: string[] = [
  'image/svg+xml',
  'image/png',
  'image/jpeg',
  'image/jpeg',
  'image/gif',
  'image/bmp',
]

export const ZIP_MIMETYPE: string[] = [
  'application/zip',
  'application/x-zip',
  'application/zip-compressed',
  'application/x-zip-compressed',
]

export const IMAGE_EXT: Extensions[] = [
  Extensions.BMP,
  Extensions.JPEG,
  Extensions.JPG,
  Extensions.GIF,
  Extensions.PNG,
]

export const ZIP_EXT: Extensions[] = [Extensions.ZIP, Extensions.RAR]

export const getFileGroupByExt = (mimeType: string): CreationGroup => {
  if (iExtensionImage(mimeType)) {
    return 'IMAGE'
  }
  if (iExtensionZIP(mimeType)) {
    return 'ZIP'
  }
  return 'OTHER'
}

export const isMimeTypeImage = (mimeType: string): boolean =>
  IMAGE_MIMETYPE.includes(mimeType)

export const isMimeTypeZIP = (mimeType: string): boolean =>
  ZIP_MIMETYPE.includes(mimeType)

export const iExtensionImage = (fileName: string): boolean =>
  new RegExp(`.(${IMAGE_EXT.join('|').toLowerCase()})$`).test(
    fileName?.toLowerCase(),
  )

export const iExtensionZIP = (fileName: string): boolean =>
  new RegExp(`.(${ZIP_EXT.join('|').toLowerCase()})$`).test(
    fileName?.toLowerCase(),
  )
